
import { useState, useEffect } from "react";

export default function Products({ supabase }) {
  const [products, setProducts] = useState([]);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("products");

  useEffect(() => { loadData(); }, []);

  async function loadData() {
    const [p, s] = await Promise.all([
      supabase.from("products").select("*, shops(name)").order("created_at", { ascending: false }),
      supabase.from("services").select("*, shops(name)").order("created_at", { ascending: false }),
    ]);
    if (p.data) setProducts(p.data);
    if (s.data) setServices(s.data);
    setLoading(false);
  }

  async function toggleItem(id, current, type) {
    await supabase.from(type).update({ is_available: !current }).eq("id", id);
    loadData();
  }

  const items = activeTab === "products" ? products : services;

  return (
    <div>
      <div style={{ display: "flex", gap: 8, marginBottom: 20 }}>
        {["products", "services"].map(t => (
          <button key={t} style={{ background: activeTab === t ? "#00A65120" : "#111", border: activeTab === t ? "1px solid #00A651" : "1px solid #333", borderRadius: 8, padding: "10px 20px", color: activeTab === t ? "#00A651" : "#666", cursor: "pointer", fontSize: 14 }} onClick={() => setActiveTab(t)}>
            {t === "products" ? "🛍️ Products" : "✂️ Services"} ({t === "products" ? products.length : services.length})
          </button>
        ))}
      </div>
      {loading ? <div style={{ color: "#666", textAlign: "center", padding: 40 }}>Loading...</div> : (
        <div style={{ background: "#111", border: "1px solid #222", borderRadius: 12, overflow: "hidden" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>{["Name", "Shop", activeTab === "products" ? "Category" : "Duration", "Price", "Status", "Actions"].map(h => <th key={h} style={{ color: "#666", fontSize: 12, fontWeight: "600", textAlign: "left", padding: "12px 16px", borderBottom: "1px solid #222", textTransform: "uppercase", background: "#0a0a0a" }}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {items.map(item => (
                <tr key={item.id} style={{ borderBottom: "1px solid #1a1a1a" }}>
                  <td style={{ color: "#ccc", fontSize: 14, padding: "12px 16px" }}>
                    {item.photo_url && <img src={item.photo_url} alt="" style={{ width: 36, height: 36, borderRadius: 6, objectFit: "cover", marginRight: 10, verticalAlign: "middle" }} />}
                    <span style={{ fontWeight: "500", color: "#fff" }}>{item.name}</span>
                  </td>
                  <td style={{ color: "#ccc", fontSize: 14, padding: "12px 16px" }}>{item.shops?.name || "N/A"}</td>
                  <td style={{ color: "#ccc", fontSize: 14, padding: "12px 16px" }}>{activeTab === "products" ? (item.category || "N/A") : (item.duration_minutes + " min")}</td>
                  <td style={{ color: "#ccc", fontSize: 14, padding: "12px 16px" }}>Le {item.price?.toLocaleString()}</td>
                  <td style={{ color: "#ccc", fontSize: 14, padding: "12px 16px" }}>
                    <span style={{ padding: "3px 10px", borderRadius: 20, fontSize: 12, fontWeight: "600", background: item.is_available ? "#00A65120" : "#e74c3c20", color: item.is_available ? "#00A651" : "#e74c3c" }}>{item.is_available ? "Live" : "Off"}</span>
                  </td>
                  <td style={{ color: "#ccc", fontSize: 14, padding: "12px 16px" }}>
                    <button style={{ border: "none", borderRadius: 6, padding: "5px 12px", fontSize: 12, fontWeight: "600", cursor: "pointer", background: item.is_available ? "#e74c3c20" : "#00A65120", color: item.is_available ? "#e74c3c" : "#00A651" }} onClick={() => toggleItem(item.id, item.is_available, activeTab === "products" ? "products" : "services")}>{item.is_available ? "Take Down" : "Restore"}</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
